import { SectionActionLink } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";

type Props = {
  onPress: () => void;
  label?: string;
};

export default function ViewAllLink({ onPress, label }: Props) {
  const t = useTranslations();
  const displayLabel = label ?? t("care.view_all");
  return <SectionActionLink label={displayLabel} onPress={onPress} />;
}
